<template>
    <div id="pursuitsDetailsComponent">
      <div style="display: flex;flex-direction: column;" v-if="!editMode">
        <div style="flex: 1;">
<!--          <div class="infoTitleRow">-->
<!--            <div class="infoTitle">{{defaultValue.companyShortName}}</div>-->
<!--            <div class="infoEditBtn" @click="toEditMode" v-if="!hideEdit">-->
<!--              <pt-icon type="icon-bianji1" class="edit_icon"></pt-icon>-->
<!--            </div>-->
<!--          </div>-->
          <a-row class="info_lines" style="margin-top: 22px">
            <a-col :span="8">
              <div class="title">{{$t('track.trackModal.trackType')}}</div>
            </a-col>
            <a-col :span="10">
              <div class="title">{{$t('track.tableLabel.demandStatus')}}</div>
            </a-col>
            <a-col :span="6">
              <div class="title">{{$t('track.tableLabel.transfer')}}</div>
            </a-col>
            <!--<a-col class="title" :span="8">-->
              <!--<div>{{$t('track.trackModal.orderRentLabel')}}:</div>-->
            <!--</a-col>-->
            <!-- 追踪类型 -->
            <a-col :span="8">
              <div class="content_text blackhillsYellow" style="color:#FABE00;">
                {{ defaultValue.trackingType == 0 ? '~' : $t('track.trackingType.'+defaultValue.trackingType)}}
              </div>
            </a-col>
            <!-- 需求状态 -->
            <a-col :span="10">
              <div class="content_text blackhillsYellow" style="color:#FABE00;">
                {{ defaultValue.demandStatus ==0 ? '~' : $t('track.demandStatus.'+(defaultValue.demandStatus-1)).name}}
              </div>
            </a-col>
            <!-- 转交易可能性 -->
            <a-col :span="6">
              <div class="content_text blackhillsYellow" style="color:#FABE00;">
                {{defaultValue.transfer}}%
              </div>
            </a-col>

            <!-- 需求面积 -->
<!--            <a-col :span="8">-->
<!--              <div class="content_text blackhillsYellow" style="color:#FABE00;">-->
<!--                {{defaultValue.demandArea | NumberFormat}}-->
<!--                <pt-unit-select type="area" v-model="defaultValue.demandAreaUnit" :edit-mode="false"></pt-unit-select>-->
<!--              </div>-->
<!--            </a-col>-->
            <!--<a-col class="title" :span="8">-->
              <!--<div class="content_text">-->
                <!--{{defaultValue.budgetRent | NumberFormat}}-->
                <!--<pt-unit-select type="rent" v-model="defaultValue.budgetRentUnit" :edit-mode="false"></pt-unit-select>-->
              <!--</div>-->
            <!--</a-col>-->
          </a-row>
          <a-row>
            <a-col :span="8" class="title">
              <div>{{$t('track.trackModal.opponentLabel')}}</div>
            </a-col>
            <a-col class="title" :span="10">
              <div>{{$t('deal.addDeal.dealDetails.targetArea')}}</div>
            </a-col>
            <a-col class="title" :span="6">
              <div>{{$t('track.tableLabel.targetBuilding')}}</div>
            </a-col>

          </a-row>
          <a-row class="info_lines">
            <a-col :span="8">
              <div class="content_text" v-if="defaultValue.colleagueDOS && defaultValue.colleagueDOS.length > 0">
                <span v-for="(c,index) in defaultValue.colleagueDOS"><span v-if="index > 0">,</span>{{c.companySortNameCn}}</span>
              </div>
              <div v-else>
                ~
              </div>
            </a-col>
            <!-- 目标区域 -->
            <a-col :span="10">
              <div class="item">
                <div class="deal_cascader">
                  <template v-if="defaultValue.targetArea!='~' && defaultValue.targetArea != '[]'">
                    <pt-multi-cascader
                       class="cascader"
                      :editMode="false"
                      disabled
                      :show-all-levels="false"
                      :value="JSON.parse(defaultValue.targetArea)"
                      :styleObj="{width: '100%'}"
                      size="small"
                      :options="allCityDatas"
                      :props="{multiple: true}"
                      :clearable="false"></pt-multi-cascader>
                  </template>
                  <template v-else>
                    ~
                  </template>
                </div>
              </div>
            </a-col>

            <a-col :span="6">
                <div class="item">
                  <div class="content_text" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
                    <a-tooltip :title="defaultValue.buildingNames">
                      <div v-for="(item,index) in  defaultValue.buildingNames.split(',')" :key="index" >
                        <span>{{item}}</span>
                      </div>


                    </a-tooltip>
                  </div>
                </div>
            </a-col>




          </a-row>

<!--          <a-row>-->
<!--            <a-col class="title" :span="8">-->
<!--              <div>{{$t('deal.addDeal.dealSource.sourceType')}}</div>-->
<!--            </a-col>-->

<!--          </a-row>-->
<!--          <a-row class="info_lines">-->
<!--            <a-col class="title" :span="8">-->
<!--              <div class="content_text">{{defaultValue.sourceType != '~'?sourceTypeMap[defaultValue.sourceType]:'~'}}</div>-->

<!--            </a-col>-->

<!--          </a-row>-->

<!--          <a-row>-->
              <!-- 备注 -->
<!--            <a-col class="title">-->
<!--              <div>{{$t('track.trackModal.remarksLabel')}}:</div>-->
<!--            </a-col>-->
<!--            <a-col>-->
<!--              <div class="content_text">{{defaultValue.remarks}}</div>-->
<!--            </a-col>-->
<!--          </a-row>-->
        </div>
      </div>
      <div v-else>
        <a-row class="save_buttons">
          <a-button @click="cancelEditMode" size="small" style="margin-right: 5px;">{{$t('baseVO.cacel')}}</a-button>
          <a-button type="primary" size="small" @click="submit">{{$t('baseVO.save')}}</a-button>
        </a-row>
        <a-row class="save_form">
          <a-form layout="vertical" :form="form">
            <a-row>
            <a-col :span="16">
              <a-form-item :label="$t('deal.addDeal.dealDetails.companyName')">
                <a-select
                  showSearch
                  v-decorator="decorators.customerId"
                  :placeholder="$t('keyqingshuru')"
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @search="handleSearch"
                  @change="customerIdChange"
                  :notFoundContent="null"
                >
                  <a-select-option v-for="d in customerList" :key="d.id" :value="d.id">
                    <div style="display:flex;">
                      <div style="flex:1;" class="invisible-item">
                        {{d.companyName}}
                      </div>
                      <div>
                        {{d.companySortNameCn}}
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('customer.customerModal.companyNameCNLabel')">
                <a-input disabled v-model="companyNameCNLabel" :placeholder="$t('customer.customerModal.companyNameCNTip')"></a-input>
              </a-form-item>
            </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-item :label="$t('track.trackModal.needAreaLabel')">
                  <a-input-group compact>
                    <pt-input-number
                      :blackhillsYellow="true"
                      style="width:70%;" v-decorator="decorators.demandArea" :placeholder="$t('track.trackModal.needAreaTip')"
                                     :max="9999999999" :precision="2"></pt-input-number>
                    <pt-unit-select style="width: 30%;" type="area" v-decorator="decorators.demandAreaUnit" disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('track.trackModal.expectStartTime')" >
                  <pt-month-picker style="width:100%;"
                                  v-decorator="decorators.expectStartDate"
                                   :blackhillsYellow="true"
                                  :placeholder="$t('track.trackModal.expectStartTimeTip')"></pt-month-picker>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('track.trackModal.propertyTypeLabel')">
                  <pt-select :placeholder="$t('track.trackModal.propertyTypeTip')" v-decorator="decorators.propertyType" :allowClear="false">
                    <a-select-option v-for="d in propertyTypes" :key="d.wordKey" :value="d.wordKey">{{d.wordValue}}</a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <!-- 客户关系 -->
<!--              <a-col :span="8">-->
<!--                <a-form-item :label="$t('track.trackModal.priority')">-->
<!--                  <ptSelect :placeholder="$t('track.trackModal.priorityTip')" v-decorator="decorators.priority" :allow-clear="false">-->
<!--                    <a-select-option v-for="c in priorityOptions" :key="c.wordKey" :value="c.wordKey">-->
<!--                      <span class="blackhillsYellow">{{c.wordValue}}</span>-->
<!--                    </a-select-option>-->
<!--                  </ptSelect>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
              <a-col :span="16">
                <a-form-item :label="$t('track.trackModal.opponentLabel')">
                  <ptSelect mode="multiple" v-model="colleagueList" :placeholder="$t('track.trackModal.opponentTip')"
                            :maxTagCount="3" :maxTagTextLength="8">
                    <a-select-option v-for="c in competitors" :key="c.id" :value="c.id">
                      <div style="display:flex;">
                        <div style="flex:1;" class="invisible-item">
                          {{c.companyName}}
                        </div>
                        <div>
                          {{c.companySortNameCn}}
                        </div>
                      </div>
                    </a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('track.trackModal.trackType')">
                  <ptSelect  :allowClear="false"  :placeholder="$t('track.trackModal.trackType')"  v-decorator="decorators.pursuitsType">
                    <a-select-option v-for="c in $t('track.trackModal.trackTypeList')" :key="c.key" :value="c.key">
                      {{c.value}}
                    </a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
            </a-row>


              <!-- 来源途径 -->
<!--                <a-col :span="8">-->
<!--                  <a-form-item :label="$t('deal.addDeal.dealSource.sourceType')">-->
<!--                    <pt-select v-decorator="decorators.sourceType"-->
<!--                               :placeholder="$t('deal.addDeal.dealSource.errorInfo.sourceType')">-->
<!--                      <a-select-option v-for="d in leaseSourceTypeOptions" :key="d.wordKey" :value="d.wordKey">{{d.wordValue}}</a-select-option>-->
<!--                    </pt-select>-->
<!--                  </a-form-item>-->
<!--                </a-col>-->
            <a-row>
              <a-col :span="24">
                <a-form-item :label="$t('track.trackModal.remarksLabel')">
                  <a-textarea  v-decorator="decorators.remarks"
                               :autosize="{minRows:3,maxRows:3}"
                               :placeholder="$t('track.trackModal.remarksTip')"
                               style="background-color:#FFFFFF !important;"
                  />
                </a-form-item>
              </a-col>
            </a-row>

<!--            <a-row>-->
<!--              <a-col :span="8">-->
<!--                <a-form-item :label="$t('track.trackModal.orderRentLabel')">-->
<!--                  <a-input-group compact>-->
<!--                    <pt-input-number precision="2" style="width:45%;" :placeholder="$t('track.trackModal.orderRentTip')"-->
<!--                                     v-decorator="decorators.budgetRent" @change="calculateBrokerage" max="99999"></pt-input-number>-->
<!--                    <pt-unit-select style="width: 55%;" type="rent" v-decorator="decorators.budgetRentUnit" disabled></pt-unit-select>-->
<!--                  </a-input-group>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :span="8">-->
<!--                <a-form-item :label="$t('track.trackModal.propertyTypeLabel')">-->
<!--                  <ptSelect v-decorator="decorators.propertyType">-->
<!--                    <a-select-option v-for="u in propertyTypes" :key="u.wordKey" :value="u.wordKey">{{u.wordValue}}</a-select-option>-->
<!--                  </ptSelect>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </a-row>-->
<!--            <a-row>-->
<!--              <a-col>-->
<!--                <a-form-item :label="$t('track.trackModal.opponentLabel')">-->
<!--                  <ptSelect mode="multiple" v-model="colleagueList" :placeholder="$t('track.trackModal.opponentTip')">-->
<!--                    <a-select-option v-for="c in competitors" :key="c.id" :value="c.id">{{c.companySortNameEn}}</a-select-option>-->
<!--                  </ptSelect>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </a-row>-->
<!--            <a-row>-->
<!--              <a-col>-->
<!--                <a-form-item :label="$t('track.trackModal.remarksLabel')">-->
<!--                  <ptInput mode="multiple" type="textarea" v-decorator="decorators.remarks" :autosize="{minRows:3,maxRows:3}">-->
<!--                  </ptInput>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </a-row>-->
          </a-form>
        </a-row>
      </div>
    </div>
</template>

<script>
  import customerApi from '@/api/mine/customer'
  import pursuitsApi from '@/api/mine/pursuit'
  import colleagueApi from '@/api/database/colleague'
  import { findCascadingData, getDatadictChildsByPath } from '@/api/sys/datadict'

  export default {
    components: {},
    name: 'dealDetailsComponent',
    data(){
      return {
        leaseSourceTypeOptions:[],
        getCustomerId:null,
        companyNameCNLabel:null,
        colleagueList:[],
        priorityOptions: [],
        editMode:false,
        form: this.$form.createForm(this,{}),
        customerList:[],
        propertyTypes:[],
        competitors:[],
        allCityDatas:[],
        projectStages:[],
        decorators:{
          customerId:['customerId',{rules:[],initialValue:null}],
          demandArea:[
            'demandArea',{}
          ],
          demandAreaUnit:[
            'demandAreaUnit',{}
          ],
          propertyType:[
            'propertyType',{}
          ],
          budgetRent:[
            'budgetRent',{}
          ],
          budgetRentUnit:[
            'budgetRentUnit',{}
          ],
          demandType:[
            'demandType',{}
          ],
          competitionSituation:[
            'competitionSituation',{}
          ],
          remarks:[
            'remarks',{rules:[{max: 256, message: this.$t('track.trackModal.remarkLengthTip'), trigger: 'blur'},]}
          ],
          pursuitsType:[
            'pursuitsType',{}
          ],
          sourceType:[
            'sourceType',{}
          ],
          expectStartDate:['expectStartDate',{rules:[]}],
          priority:['priority',{rules:[],initialValue:'Column_A'}],
        }
      }
    },
    props:{
      hideEdit:{
        type:Boolean,
        default:false,
      },
      defaultValue:{
        type: Object,
        default: ()=>{
          return {}
        }
      }
    },
    mounted(){
      this.init();
      this.initServiceDealSourceTypes();
    },
    computed:{
      // priorityName(){
      //   if(this.priorityOptions.length == 0){
      //     return ''
      //   }else{
      //     let name = this.priorityOptions.find(e=>{ return e.wordKey == this.defaultValue.priority}).wordValue
      //     return name
      //   }
      // },
      sourceTypeMap(){
        var arr = [];
        this.leaseSourceTypeOptions.forEach(data=>{
          arr[data.wordKey] = data.wordValue;
        })
        return arr;
      },
    },
    methods:{
      initServiceDealSourceTypes(){
        let this_ = this
        getDatadictChildsByPath('system.business_key.deal_source_set').then(res=>{
          this_.leaseSourceTypeOptions = res.data.filter(e=>{return e.wordKey != 'approach' && e.wordKey != 'invited'})
          // this_.leaseSourceTypeOptions = res.data;
        })
      },
      formatStartDate(date) {
        if(date == '~'){
          return '~'
        }else{
          return this.$moment(date).format('YYYY-MM')
        }
      },
      customerIdChange(value){
        this.getCustomerId = value
        let customerDO = this.customerList.find(e=>{ return e.id == value })
        this.companyNameCNLabel = customerDO.companySortNameCn
      },
      calculateBrokerage(){

      },
      cancelEditMode(){
        this.editMode = false;
        // this.$emit('cancelEditMode')
      },
      handleSearch(customerName){
        setTimeout(()=>{
          let this_ = this
          customerApi.queryByName({name: customerName}).then(res => {
            this_.customerList = res.data
          })
        },300);
      },
      init(){
        this.initCustomerRelationShipOptions()
        this.initCustomerList()
        this.initCompetitors()
        this.initPropertyTypes()
        this.initCityData()
      },
      initCompetitors(){
        colleagueApi.selectAll().then(res=>{
          if(res.code == 1){
            this.competitors = res.data.records
          }
        })
      },
      initCustomerRelationShipOptions(){
        customerApi.getCustomerRelationShipOptions().then(res=>{
          if(res.code == 1){
            this.priorityOptions = res.data
            this.priorityOptions.sort((a,b)=>{
              return a.listIndex - b.listIndex
            })
          }
        })
      },
      initCustomerList(){
        let this_ = this
        if(this.defaultValue.customerId){
          customerApi.selectOne(this.defaultValue.customerId).then(res=>{
            this_.customerList.push(res.data)
          })
        }
      },
      initCityData(){
        let this_ = this
        findCascadingData("system.mansion_set.address",4).then(res=>{
          this_.allCityDatas = res.data
          let data
          for(let i = 0; i < res.data.length; i++){
            //只显示员工公司所在地
            data = this_.buildNewTree(res.data[i],this_.$store.getters.userInfo.companyDO.city.toLowerCase())
            if(data){
              break
            }
          }
          this_.cityDatas = data
        })
      },
      buildNewTree(tree,equalsValue){
        let stack = [tree]
        if(tree.value != equalsValue){
          for(let i = 0; i < tree.children.length; i++){
            if(tree.children[i].value == equalsValue){
              return stack
            }
          }
        }else{
          return stack
        }
      },
      toEditMode(){
        this.editMode = true
        this.$nextTick(()=>{
          this.colleagueList = this.defaultValue.colleagueDOS != null ? this.defaultValue.colleagueDOS.map(e=>{return e.id}) : []
          this.companyNameCNLabel = this.defaultValue.companyShortName;
          let defaultValue = JSON.parse(JSON.stringify(this.defaultValue))
          defaultValue.expectStartDate = this.defaultValue.expectStartDate == '~' ? null : this.$moment(this.defaultValue.expectStartDate)
          this.form.setFieldsValue(defaultValue)
        })
      },
      initPropertyTypes(){
        let propertyTypes = this.$t('deal.propertyTypes')
        for(var p in propertyTypes){
          this.propertyTypes.push({wordKey:p,wordValue:propertyTypes['' + p]})
        }
      },
      submit(){
        let pursuitDO = this.form.getFieldsValue()
        pursuitDO.id = this.defaultValue.id
        pursuitDO.depId = this.defaultValue.depId
        pursuitDO.version = this.defaultValue.version
        pursuitDO.colleagueDOS = this.colleagueList.map(e=>{return {id: e}})
        pursuitsApi.updatePursuitsDetails(pursuitDO).then(res => {
          if(res.code == 1){
            this.$message.success("保存成功")
            this.$emit('onSuccess')
            this.editMode = false
          }else{
           // this.$message.error(res.message)
          }
        })
      }
    },
    watch:{
      defaultValue(){
        if(this.defaultValue != null){
          this.init()
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../../../core/diy.less';
  #pursuitsDetailsComponent{
    .blackhillsYellow{
      color: @blackhills-yellow !important;
    }
    .infoTitleRow{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .infoTitle{
        font-size: 17px;
        color: #333333;
        font-weight: bold;
      }
      .infoEditBtn{
        font-size: 12px;
        color: #8E8E8E;
        cursor: pointer;
      }
      .infoEditBtn:hover{
        color: #FABE00;
      }
    }
    .customer_name{
      font-size: 17px;
      color: #333333;
      margin-bottom: 10px;
      font-weight: bold;
    }
    .info_lines{
      margin-bottom: 15px;
    }
    .title{
      font-size: 12px;
      color: #999999;
    }
    .content_text{
      font-size: 12px;
      color: #333333;
    }
    .edit_icon{
      font-size: 18px;
      float:right;
      cursor:pointer;
    }
    .ant-form-vertical .ant-form-item{
      padding: 0 10px;
    }
    .save_buttons{
      display: flex; justify-content: flex-end;padding-top: 5px;
    }
    .save_form{
      padding: 18px 10px 0 10px;
    }

    .deal_cascader{
      /deep/ .el-input__inner{
        padding-left:4px !important;
      }
      /deep/ .el-tag{
        margin-left: 0px !important;
        margin-right: 6px !important;
      }
    }

    .value{
      font-size: 12px;
      color: #333333;
      letter-spacing: 0;

    }
  }
  /deep/.invisible-item{
    display:none;
  }
</style>
<style lang="less">
  .ant-select-dropdown-content{
    /deep/.invisible-item{
      display:initial !important;
    }
  }
</style>